import { cn } from "@/lib/client/utils";

export interface ContainerProps {
  children: React.ReactNode;
  center?: boolean;
}
export const Container = ({ children, center = false }: ContainerProps) => {
  return (
    <div
      className={cn(
        "flex flex-col h-screen w-full mx-auto max-w-5xl",
        center && "items-center justify-center"
      )}
    >
      {children}
    </div>
  );
};
